import { SignupUserAPI, addUserAPI, getUserAPI, getUserByEmailAPI, updateUserAPI } from "api/user.api";
import { useMutation, useQuery } from "react-query";
import { User, UserInput } from "types/user";

const USERS_RQ_KEY = "users";


export const useAddUserToFundMutation = () => {
  return useMutation<unknown, unknown, UserInput>({
    mutationKey: [USERS_RQ_KEY],
    mutationFn: (data) => addUserAPI(data),
  })
}

export const useUpdateUserMutation = () => {
  return useMutation<unknown, unknown, UserInput>({
    mutationKey: [USERS_RQ_KEY],
    mutationFn: (data) => updateUserAPI(data),
  })
}
export const useSignupUserMutation = () => {
  return useMutation<unknown, unknown, UserInput>({
    mutationKey: [USERS_RQ_KEY],
    mutationFn: (data) => SignupUserAPI(data),
  })
}
export const useGetUserQuery = (sub: string) => {
  return useQuery<User | null>({
    queryKey: [USERS_RQ_KEY, sub],
    enabled: Boolean(sub),
    queryFn: async () => {
      if (!sub) {
        return null;
      }
      const res: unknown = await getUserAPI(sub);
      if (res == null || res === "") {
        return null;
      }
      if (typeof res === "string" && res.trim() === "") {
        return null;
      }
      return res as User;
    },
  });
};
export const useGetUserByEmailQuery = (email: string) => {
  return useQuery<User>({
    queryKey: [USERS_RQ_KEY, email],
    enabled: email !== null && email !== '',
    queryFn: () => getUserByEmailAPI(email),
  })

}

